import { Box, Grid } from '@mui/material';
import GridTutorialCard from './GridTutorialCard';
import ListTutorialCard from './ListTutorialCard';

const Content = ({ data, activeView, searchQuery }) => {
  const filteredData = data.filter(item => {
    const name = item.name?.toLowerCase() || '';
    const topic = item.topic?.toLowerCase() || '';
    const description = item.description?.toLowerCase() || '';
    const mentor = item.mentor?.toLowerCase() || '';
    const query = searchQuery.toLowerCase();

    return (
      name.includes(query) ||
      topic.includes(query) ||
      description.includes(query) ||
      mentor.includes(query)
    );
  });

  return (
    <Box sx={{ width: '100%' }}>
<Grid
  container
  spacing={2}
  sx={{
    width: '100%',
    m: 0,            // 🔥 removes negative margin overflow
  }}
>


        {filteredData.map(item => (
          <Grid
            item
            key={item.id}
            xs={12} // 1 per row on mobile
            sm={activeView === 0 ? 6 : 12} // 2 per row on tablet
            md={activeView === 0 ? 4 : 12} // 3 per row on desktop
          >
            {activeView === 0 ? <GridTutorialCard item={item} /> : <ListTutorialCard key={item.id} item={item} />}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Content;
